import React from 'react';
import ChangeSettingForm from '../ChangeSettingForm';

const ChangeUserName = () => (
    <ChangeSettingForm
        label="Username"
        endpoint="/api/c/changeusername/"
        apiParamName="new_username"
        reduxField="username"
        transform={(v) => v.toLowerCase()}
    />
);

export default ChangeUserName;
